import React from "react";

import { Link } from "react-router-dom";

export default function Unternehmen() {
	return (
		<>
			<div className="beratungs-menu">
				<div className="box-menu">
					<div className="field-preview">
						<div className="picture-cards-lg beratun_icons">
							<Link
								to="/unternehmen/managment_team"
								className="picture-cards-lg__card beratun_Deal animated-div"
							>
								<span className="picture-cards-lg__card-title ">
									<span className="picture-cards-lg__card-title-wrapper">
										Management Team
									</span>
								</span>
							</Link>
							<Link
								to="/unternehmen/blog"
								className="picture-cards-lg__card beratun_Corporate animated-div"
							>
								<span className="picture-cards-lg__card-title ">
									<span className="picture-cards-lg__card-title-wrapper">
										Blog
									</span>
								</span>
							</Link>
						</div>
					</div>
					<div className="field-preview">
						<div className="picture-cards-lg beratun_icons">
							<Link
								to="/unternehmen/kooperationspartner"
								className="picture-cards-lg__card beratun_ESG animated-div"
							>
								<span className="picture-cards-lg__card-title ">
									<span className="picture-cards-lg__card-title-wrapper">
										Kooperationspartner
									</span>
								</span>
							</Link>
							<Link
								to="/unternehmen/karriere"
								className="picture-cards-lg__card beratun_Governance animated-div"
							>
								<span className="picture-cards-lg__card-title ">
									<span className="picture-cards-lg__card-title-wrapper">
										Karriere
									</span>
								</span>
							</Link>
						</div>
					</div>
					<div className="field-preview">
						<div className="picture-cards-lg beratun_icons">
							<Link
								to="/unternehmen/referenzen"
								className="picture-cards-lg__card beratun_Fokusthema animated-div"
							>
								<span className="picture-cards-lg__card-title ">
									<span className="picture-cards-lg__card-title-wrapper">
										Referenzen
									</span>
								</span>
							</Link>
						</div>
					</div>
				</div>

				<aside className="contact-sec beratun_kontakt">
					<p>
						Setzen Sie sich mit uns in Verbindung und lassen Sie sich
						unverbindlich beraten.
					</p>
					<a className="link-button" href="/kontakt">
						Kontaktieren Sie uns
					</a>
				</aside>
			</div>
		</>
	);
}
